import styled from 'styled-components';
import Cards from '../../Cards/Cards';
import { DEVICES } from '../../../config/appConfig';

export const StyledCard = styled(Cards)`
  width: calc(100% / 3 - 20px);
  padding: 0px;
  .keyBenefitImgStyle {
    width: 100%;
  }
  @media ${DEVICES.tablet} {
    width: calc(100% / 3 - 20px);
  }

  @media ${DEVICES.mobile} {
    width: calc(100% / 2 - 20px);
  }

  @media ${DEVICES.sMobile} {
    width: 100%;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  padding: 20px 10px;
  font-family: Rubik;
  font-size: 18px;
  & img {
    height: 50px;
    width: 50px;
  }
  @media ${DEVICES.tablet} {
    img {
      height: 42px;
      width: 42px;
    }
  }

  @media ${DEVICES.mobile} {
    img {
      height: 38px;
      width: 38px;
    }
  }

  @media ${DEVICES.sMobile} {
    img {
      height: 32px;
      width: 32px;
    }
  }
`;

export const OurServicesContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1400px;
  margin: 0px auto;
  gap: 20px;
`;

export const StyledConatiner = styled.div`
  width: 100%;
`;
